import styled from 'styled-components';
import { palette } from 'styled-tools';

import { TextButton } from '@calm-web/design-system';

import playIcon from 'icons/play-outline.svg';

export const Wrapper = styled.li`
	align-items: center;
	cursor: pointer;
	display: flex;
	opacity: 1;
	padding: 16px 0 24px;
	text-align: left;
	z-index: 0;
`;

export const ClickableWrapper = styled(TextButton).attrs({
	textColor: 'white',
})`
	text-align: left;
	text-decoration: none;
	flex: 1;
	padding-right: 16px;
`;

export const Title = styled.div`
	color: ${palette('white')};
	font-weight: 500;
	margin-bottom: 4px;
	text-align: left;
	width: 100%;
`;

export const Subtitle = styled.div`
	color: ${palette('white')};
	font-weight: 400;
	margin-bottom: 8px;
	text-align: left;
	width: 100%;
`;

export const Duration = styled.div`
	font-size: 13.5px;
	font-weight: 700;
`;

export const PlayIcon = styled(playIcon)`
	flex: 0 0 24px;
	height: 24px;
	position: relative;
	width: 24px;

	& path {
		fill: ${palette('white')};
	}
`;
